import { Button, Link } from '@heroui/react';

export const UserUnauthenticatedCard = () => {
  return (
    <div className="p-4 bg-[#E2EAFB] rounded-xl">
      <p className="font-semibold text-[#222222]">Вы не вошли в аккаунт</p>
      <p className="text-[#60656C] mt-2 text-sm">
        Войдите, чтобы оформлять заказы и просматривать историю покупок
      </p>
      <Button
        radius="lg"
        as={Link}
        fullWidth
        href="/authorization"
        variant="solid"
        color="primary"
        className="mt-4"
        size="lg"
      >
        Войти
      </Button>
    </div>
  );
};

export type UserAuthenticatedCardProps = {
  name: string;
  phone: string;
};

export const UserAuthenticatedCard = ({
  name,
  phone,
}: UserAuthenticatedCardProps) => {
  return (
    <div className="flex flex-row bg-[#F8F9FA] p-4 justify-between items-center rounded-xl">
      <div className="flex flex-col gap-y-3">
        <p className="font-semibold text-[#222223] text-base">{name}</p>
        <p className="text-[#6B767F]">{phone}</p>
      </div>

      <Button
        radius="full"
        as={Link}
        href="/profile/edit"
        variant="bordered"
        className="lg:hidden"
        size="md"
      >
        Изменить
      </Button>
    </div>
  );
};
